import React from "react";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import { useCurrentUser, useRole } from "@queries";
import { useClassroomsStats } from "@queries/organization";

export function ClassroomDropdownList({
  className,
  onClassroomSelected,
  selectedClassroom,
  orgCode,
  placeholder = "Select a classroom...",
  icon,
}) {
  const currentUser = useCurrentUser();
  const role = useRole();
  const { userId, organizationCode } = currentUser || {};

  const effectiveOrgCode = orgCode ?? organizationCode;

  const { data: classrooms, isLoading: loading } = useClassroomsStats(
    { userId, role, orgCode: effectiveOrgCode },
    {
      enabled: !!(userId && role && effectiveOrgCode),
    }
  );

  return (
    <div className={className}>
      <div className="section-title"> Classroom </div>
      <Dropdown
        selected={selectedClassroom}
        onOptionSelected={onClassroomSelected}
        disabled={loading}
      >
        <DropdownButton placeholder={placeholder} icon={icon} required>
          {selectedClassroom?.name}
        </DropdownButton>
        <DropdownItems>
          {classrooms?.map((classroom, i) => (
            <DropdownItem key={`${classroom.id}-cd-${i}`} value={classroom}>
              {classroom.name}
            </DropdownItem>
          ))}
        </DropdownItems>
      </Dropdown>
    </div>
  );
}
